var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventViewer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7801_9062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49414 13.5029H1.49414C1.22892 13.5029 0.97457 13.3976 0.787034 13.21C0.599497 13.0225 0.494141 12.7681 0.494141 12.5029V1.50293C0.494141 1.23771 0.599497 0.983359 0.787034 0.795823C0.97457 0.608287 1.22892 0.50293 1.49414 0.50293H8.57947C8.71082 0.50287 8.84089 0.528686 8.96225 0.578902C9.08362 0.629119 9.1939 0.702752 9.28681 0.795596L11.2001 2.7096C11.2931 2.80245 11.3669 2.91271 11.4172 3.03407C11.4675 3.15544 11.4934 3.28554 11.4935 3.41693V5.50293",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99414 3.50293H4.99414C4.718 3.50293 4.49414 3.72679 4.49414 4.00293V6.00293C4.49414 6.27907 4.718 6.50293 4.99414 6.50293H5.99414C6.27028 6.50293 6.49414 6.27907 6.49414 6.00293V4.00293C6.49414 3.72679 6.27028 3.50293 5.99414 3.50293Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49414 3.50293V6.50293",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49414 3.50293V6.50293",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99414 8.50293H2.99414C2.718 8.50293 2.49414 8.72679 2.49414 9.00293V11.0029C2.49414 11.2791 2.718 11.5029 2.99414 11.5029H3.99414C4.27028 11.5029 4.49414 11.2791 4.49414 11.0029V9.00293C4.49414 8.72679 4.27028 8.50293 3.99414 8.50293Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5137 11.1712C13.5137 11.1712 12.4281 13.3424 10.2568 13.3424C8.08561 13.3424 7 11.1712 7 11.1712C7 11.1712 8.08561 9 10.2568 9C12.4281 9 13.5137 11.1712 13.5137 11.1712Z",
    strokeWidth: 0.723741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2575 12.2572C10.8571 12.2572 11.3431 11.7711 11.3431 11.1715C11.3431 10.572 10.8571 10.0859 10.2575 10.0859C9.65792 10.0859 9.17188 10.572 9.17188 11.1715C9.17188 11.7711 9.65792 12.2572 10.2575 12.2572Z",
    strokeWidth: 0.723741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7801_9062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventViewer);
export default __webpack_public_path__ + "static/media/event_viewer.b72e9749.svg";
export { ForwardRef as ReactComponent };